/**
 * Licence Ping
 * @author Rhys Lloyd
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'licence-ping';
const log = debug(MODULE_NAME);

// Dependencies
const TIMEOUT_DEFAULT = 1500;
const RESOLVED = 'resolved';
const REJECTED = 'rejected';
const RESPONDED = 'responded';

/**
 * Source: http://stackoverflow.com/a/31424853/1053199
 * @param {Promise} promise
 * @returns {Promise}
 */
function reflect(promise) {
	return promise.then(
		value => ({ value, status: RESOLVED }),
		error => ({ error, status: REJECTED })
	);
}

/**
 * Pings provided URL and returns a promise for the request.
 * @param {Object} urlObject
 * @param {Number} timeout
 * @returns {Promise}
 */
export function pingUrl (urlObject, timeout = TIMEOUT_DEFAULT) {
	return new Promise((resolve, reject) => {
		let loading = true,

			// Default type is CSS
			elementTag = 'link',
			timeoutId = 0;

		switch (urlObject.type) {
			case 'js':
				elementTag = 'script';
		}

		const element = document.createElement(elementTag);

		const respondedFn = () => {
			if (loading) {
				loading = false;
				clearTimeout(timeoutId);
				log(`Pinged "${urlObject.url}"`);
				resolve({url: urlObject.url, type: urlObject.type, status: RESPONDED});
			}
		};

		const rejectFn = (e) => {

			if (loading) {
				const errorResponse = {url: urlObject.url, type: urlObject.type, status: REJECTED, error: e};
				// noinspection ReuseOfLocalVariableJS
				loading = false;
				clearTimeout(timeoutId);
				log(`Ping failed for`, errorResponse);
				reject(errorResponse);
			}
		};

		element.onload = respondedFn;
		element.onerror = rejectFn;

		// Ping URL
		switch (urlObject.type) {
			case 'js':
				element.src = urlObject.url;
				break;
			default:
				element.rel = 'stylesheet';
				element.href = urlObject.url;
		}

		document.head.appendChild(element);

		if (timeout) {
			//noinspection ReuseOfLocalVariableJS
			timeoutId = setTimeout(rejectFn, timeout);
		}
	});
}

/**
 *
 * @param {Array} urls - Array of URLs to ping.
 * @param {Function=} resolve
 * @returns {Promise} Promise - Always resolves success, however object returned contains status.
 */
export default function (urls, resolve = value => value) {
	const promises = [];
	//noinspection JSUnresolvedFunction
	urls.forEach(url => promises.push(pingUrl(url).then(resolve)));
	return Promise.all(promises.map(reflect)).then(results => {
		const completedResults = results.filter(result => result.status === RESOLVED),
			failedResults = results.filter(result => result.status === REJECTED);

		const completedUrls = completedResults.map(x => x.value.url),
			failedUrls = failedResults.map(x => x.error.url);

		log('Pings completed', completedUrls);
		log('Pings failed', failedUrls);

		// Pass onto chain
		return results;
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/licence-ping/index.js